import { useQuery } from '@tanstack/react-query';
import { getOrder } from 'utils/OrderWebAPIUtils';
export function isReadyToBill(status) {
    return status === 'ready_to_bill';
}
export function useOrderBillingStatus(orderId) {
    return useQuery(['order-billing-status', orderId], async () => {
        var _a, _b, _c;
        const res = await getOrder(orderId);
        const billingStatus = (_c = (_b = (_a = res === null || res === void 0 ? void 0 : res.entity) === null || _a === void 0 ? void 0 : _a.order) === null || _b === void 0 ? void 0 : _b.order_billing_status_state) === null || _c === void 0 ? void 0 : _c.billing_status;
        return { status: billingStatus || 'incomplete' };
    }, {
        enabled: Boolean(orderId),
        staleTime: 30000,
    });
}
